/**
 * Сторож несохранённого.
 *
 * Уход с экрана бывает не только по его собственной кнопке возврата: снизу
 * всегда висит таббар, и вкладку можно сменить в любой момент. Таббар живёт в
 * App.tsx и про то, что где-то открыт редактор с ненабранным на сервере
 * текстом, знать не может — а молча выбрасывать игрока из анкеты нельзя, это
 * ровно тот случай, ради которого заведено окно «сохранить или уйти».
 *
 * Поэтому сторож общий и живёт МОДУЛЕМ, а не контекстом: держатель всегда
 * один (двух открытых редакторов не бывает), а контекст заставлял бы
 * перерисовывать всё дерево приложения на каждый набранный символ.
 *
 * Системный «назад» (кнопка Android, «назад» браузера) сюда не приходит: он
 * шагает по истории, не спрашивая приложение. Его останавливает блокировщик
 * роутера в самом экране, и уход, отпущенный вопросом отсюда, экран обязан
 * пропустить мимо блокировщика, иначе игрок услышит вопрос дважды.
 */

/** Экран получает намерение уйти и сам решает, когда его исполнить. */
type Ask = (proceed: () => void) => void;

let ask: Ask | null = null;

/** Взять уход на себя, пока экран открыт. `null` снимает сторожа. */
export function holdLeave(next: Ask | null): void {
  ask = next;
}

/** Уйти. Держит ли кто-то несохранённое, знает только сам сторож. */
export function leaveGuarded(proceed: () => void): void {
  if (ask === null) {
    proceed();
    return;
  }

  ask(proceed);
}
